import { ref } from 'vue'

type EventCallback = (payload: any) => void

interface EventBusType {
  [key: string]: EventCallback[]
}

const eventBus = ref<EventBusType>({})

export function emitEvent(event: string, payload: any) {
  if (!eventBus.value[event]) return
  eventBus.value[event].forEach((callback: EventCallback) => callback(payload))
}

export function onEvent(event: string, callback: EventCallback): () => void {
  if (!eventBus.value[event]) {
    eventBus.value[event] = []
  }
  eventBus.value[event].push(callback)

  // Return a cleanup function to remove this specific callback
  return () => offEvent(event, callback)
}

export function offEvent(event: string, callback: EventCallback) {
  if (!eventBus.value[event]) return
  eventBus.value[event] = eventBus.value[event].filter((cb: EventCallback) => cb !== callback)
}
